import { notification } from 'antd';
import axios from 'axios';
import store from 'store';
import { logout } from 'utils';
import cookies from 'js-cookie';

const token = store.get('token');

let bearerToken;
if (token !== null) {
	bearerToken = `Bearer ${token}`;
}

const resolve = (response) => {
	return response
  };

  const reject = (error) => {
	const url = error?.response?.config?.url;
	const errorStatus = error?.response?.status;
  
	// on expired, or invalid token
	if (errorStatus === 401 && !url.includes("auth")) {
	  return logout();
	}
  
	if (error.message === "timeout") {
	  return notification.error({
		message: "Timeout",
		description:
		  "Oh, Sorry! This is taking longer than expected. Please, try again later",
	  });
	}
	const { data, status } = error.response || {};

  
	if (status === 401) {
	  return  error
	}
	if (status === 500) {
	  const isOnline = navigator.onLine;
	  return isOnline
		? notification.error({
			message: "error",
			description: "Something went wrong. Please try again later",
		  })
		: notification.error({
			message: "No internet connection",
			description:
			  "Please make sure your device is connected to the internet and try again",
		  });
	}
  
	const message = data.message || error.message;
  
	if (Array.isArray(message)) {
	  const errorList = (
		<ul>
		  {message.map((item, i) => {
			return <li key={i}>{item}</li>;
		  })}
		</ul>
	  );
	  return notification.error({
		message: "Error",
		description: errorList,
	  });
	}
	notification.error({
	  message: "Error",
	  description: message?.message || message?.error || message,
	});
	return error;
  };

 const instance = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	headers: {
		authorization: bearerToken,
		'Access-Control-Allow-Origin': '*',
		contentType: 'aplication/json',
		accept: 'application/json',
		"Accept-Language": cookies.get('i18next')
	},
});

instance.interceptors.response.use(resolve, reject);

export default instance;
